import SelectSettings from './select_setting';

export default SelectSettings;
